<template>
    <select class="top-bar__select form__input form__select" :value="selectedLang" v-model="selected" @change="changeLang(selected)">
        <option v-for="lang in langlist" :value="lang.value" :key="lang.id">{{ lang.text}}</option>
    </select>
</template>

<script>
let venue_id = window.venue_id ? JSON.parse(window.venue_id) : '';
export default {

    data() {
        return {
            someData: '',
            lang : 'en',
            selected: ''
        }
    },
    computed: {
      strings () {
  	    return this.$store.state.strings
      },
      selectedLang () {
        this.selected = this.$store.state.selectedLang;
        return this.$store.state.selectedLang
      },
      langlist () {
          switch (window.location.host) {
              case 'cwteasymeetings.com':
                  return [
                        {id: 1, text: 'English', value: 'en' },
                        {id: 2, text: 'Suomi', value: 'fi' },
                        {id: 3, text: 'Français', value: 'fr' },
                        {id: 4, text: 'Deutsch', value: 'de' },
                        {id: 5, text: 'Italiano', value: 'it' },
                        {id: 6, text: 'Español', value: 'es' },
                        {id: 7, text: 'Svenska', value: 'sv' },
                        {id: 8, text: 'US English', value: 'en-us' },
                    ]
                  break;
              case 'meetings.islandshotel.is':
                  return [
                        {id: 1, text: 'English', value: 'en' },
                        {id: 21, text: 'Íslenska', value: 'is' },
                    ]
                  break;
              case 'meetings.primehotels.fi':
                  return [
                        {id: 1, text: 'English', value: 'en' },
                        {id: 3, text: 'Suomi', value: 'fi' },
                    ]
                  break;
              default:
                  return [
                        {id: 1, text: 'English', value: 'en' },
                        {id: 2, text: 'Dansk', value: 'da' },
                        {id: 3, text: 'Suomi', value: 'fi' },
                        {id: 4, text: 'Français', value: 'fr' },
                        {id: 5, text: 'Deutsch', value: 'de' },
                        {id: 6, text: 'Italiano', value: 'it' },
                        {id: 7, text: 'Latviešu', value: 'lv' },
                        {id: 8, text: 'Русский', value: 'ru' },
                        {id: 9, text: 'Español', value: 'es' },
                        {id: 10, text: 'Svenska', value: 'sv' },
                        {id: 11, text: 'Türkçe', value: 'tr' },
                        {id: 12, text: 'Čeština', value: 'cs' },
                        {id: 13, text: 'Norsk', value: 'nb' },
                        {id: 14, text: 'Eesti', value: 'et' },
                        {id: 15, text: 'Nederlands', value: 'nl' },
                        {id: 16, text: 'Polska', value: 'pl' },
                        {id: 17, text: 'US English', value: 'en-us' },
                        {id: 18, text: 'Slovak', value: 'sk' },
                        {id: 19, text: 'Slovenščina', value: 'sl' },
                        {id: 20, text: 'Magyar', value: 'hu' },
                        {id: 21, text: 'Íslenska', value: 'is' },
                    ]
                  break;
          }
      },
      isBE() {
        return this.$store.state.isBE;
      },
      useNewVenuePage() {
        return this.$store.state.useNewVenuePage;
      }
    },

    methods: {
        changeLang (lang){

            // translate 
            if ( lang != this.$store.state.detectedLanguage) {
                this.$store.commit('translatedLanguage', this.$store.state.venueInfo.description);
                this.$store.commit('isTranslated', false);
            } else {
                this.$store.state.translatedLanguage = this.$store.state.venueInfo.description;
            }

            this.$store.dispatch('changeLanguage', {
                lang: lang,
                alias: 'yes'
            });

            if (this.isBE && this.useNewVenuePage) {
                this.$store.dispatch('getNewVenue', {
                    lang: lang,
                    alias: this.$store.state.alias,
                    venueID: venue_id
                })
            } else {
                this.$store.dispatch('getVenue', {
                    lang: lang,
                    alias: this.$store.state.alias,
                    venueID: venue_id
                })
            }
        },
    }
}
</script>
